export default __webpack_public_path__ + "static/media/os_almalinux.428ec563.svg";